import {IRegulationPresetValues} from '../regulation-preset-values.interface';

export const SWEDEN_PRESETS_VALUES: IRegulationPresetValues = {
    sdk: {
        Skin: {
            regulationID: 15,
            brandID: 81,
            subBrandID: 129,
        },
        Currency: {
            anonymousCurrency: 'SEK'
        }
    },
    orbit: {
        country: 'swe',
        language: 'swe',
        iso2: 'sv',
        publicationID: 1880,
        cmsSource: 'https://www.888casino.se'
    }
}